import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Checkbox, Label, TextInput } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { AutomovilesBienes } from "../../../../../interfaces/AutomovilesBienesInterface";
import { BienesRaices } from "../../../../../interfaces/BienesRaicesInterface";
import { NotasBienes } from "../../../../../interfaces/NotasBienesInterface";
import { SituacionInmuebleInterface } from "../../../../../interfaces/SituacionInmuebleInterface";
import { ZonaInterface } from "../../../../../interfaces/ZonaInterface";
import { TipoZonaInterface } from "../../../../../interfaces/TipoZonaInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";
import HeaderBienesInmuebles from "../../../../../img/Header_BienesInmuebles.png";
import BarraBienesInmuebles from "../../../../../img/Barra_BienesInmuebles.png";

export const BienesListaPrint = () => {
  const tituloFormulario = "BIENES INMUEBLES / MUEBLES";
  const { control, reset, handleSubmit, setValue } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const queryAuto = useGetData<AutomovilesBienes[]>({
    url: `/autobienes/${evaluadosList_id}`,
    name: ["autobienes"],
  });
  const queryBienesRaices = useGetData<BienesRaices[]>({
    url: `/bienesraices/${evaluadosList_id}`,
    name: ["bienesraices"],
  });

  const queryNotasBienes = useGetData<NotasBienes[]>({
    url: `/notas-bienes-inmuebles/${evaluadosList_id}`,
    name: ["notas-bienes-inmuebles"],
  });

  const querySituacionInmueble = useGetData<SituacionInmuebleInterface[]>({
    url: `/situacion-inmueble/${evaluadosList_id}`,
    name: ["situacion-inmueble"],
  });

  const queryZonaInmueble = useGetData<ZonaInterface[]>({
    url: `/zona-inmueble/${evaluadosList_id}`,
    name: ["zona-inmueble"],
  });

  const queryTipoZona = useGetData<TipoZonaInterface[]>({
    url: `/tipo-zona/${evaluadosList_id}`,
    name: ["tipo-zona"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const [situacionSeleccionada, setSituacionSeleccionada] = useState<
    string | null
  >(null);

  const [zonaSeleccionada, setZonaSeleccionada] = useState<string | null>(null);

  const [tipoZonaSeleccionada, setTipoZonaSeleccionada] = useState<
    string | null
  >(null);

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    console.log("queryFecha.data:", queryFecha.data);

    if (queryFecha.data && queryFecha.data.length > 0) {
      const registroValido = queryFecha.data.find(
        (item) => item.fecha_bienesinmuebles
      );

      if (registroValido) {
        setValue("fecha_bienesinmuebles", registroValido.fecha_bienesinmuebles);
      }
    }
  }, [queryFecha.data, setValue]);

  useEffect(() => {
    console.log("queryAuto.data:", queryAuto.data);
    if (queryAuto.data && queryAuto.data.length > 0) {
      const auto = queryAuto.data[0];
      reset({
        marca_autobienes1: auto.marca_autobienes1 || "",
        modelo_autobienes1: auto.modelo_autobienes1 || "",
        precio_autobienes1: auto.precio_autobienes1 || "",
        liquidado_nombre_autobienes1: auto.liquidado_nombre_autobienes1 || "",
        marca_autobienes2: auto.marca_autobienes2 || "",
        modelo_autobienes2: auto.modelo_autobienes2 || "",
        precio_autobienes2: auto.precio_autobienes2 || "",
        liquidado_nombre_autobienes2: auto.liquidado_nombre_autobienes2 || "",
        marca_autobienes3: auto.marca_autobienes3 || "",
        modelo_autobienes3: auto.modelo_autobienes3 || "",
        precio_autobienes3: auto.precio_autobienes3 || "",
        liquidado_nombre_autobienes3: auto.liquidado_nombre_autobienes3 || "",
        marca_autobienes4: auto.marca_autobienes4 || "",
        modelo_autobienes4: auto.modelo_autobienes4 || "",
        precio_autobienes4: auto.precio_autobienes4 || "",
        liquidado_nombre_autobienes4: auto.liquidado_nombre_autobienes4 || "",
        marca_autobienes5: auto.marca_autobienes5 || "",
        modelo_autobienes5: auto.modelo_autobienes5 || "",
        precio_autobienes5: auto.precio_autobienes5 || "",
        liquidado_nombre_autobienes5: auto.liquidado_nombre_autobienes5 || "",
      });
    }
  }, [queryAuto.data, reset]);

  useEffect(() => {
    console.log("queryBienesRaices.data:", queryBienesRaices.data);
    if (queryBienesRaices.data && queryBienesRaices.data.length > 0) {
      const bienes = queryBienesRaices.data[0];
      reset({
        tipo_bienes1: bienes.tipo_bienes1 || "",
        ubicacion_bienes1: bienes.ubicacion_bienes1 || "",
        precio_bienes1: bienes.precio_bienes1 || "",
        liquidado_nombre_bienes1: bienes.liquidado_nombre_bienes1 || "",
        tipo_bienes2: bienes.tipo_bienes2 || "",
        ubicacion_bienes2: bienes.ubicacion_bienes2 || "",
        precio_bienes2: bienes.precio_bienes2 || "",
        liquidado_nombre_bienes2: bienes.liquidado_nombre_bienes2 || "",
        tipo_bienes3: bienes.tipo_bienes3 || "",
        ubicacion_bienes3: bienes.ubicacion_bienes3 || "",
        precio_bienes3: bienes.precio_bienes3 || "",
        liquidado_nombre_bienes3: bienes.liquidado_nombre_bienes3 || "",
        tipo_bienes4: bienes.tipo_bienes4 || "",
        ubicacion_bienes4: bienes.ubicacion_bienes4 || "",
        precio_bienes4: bienes.precio_bienes4 || "",
        liquidado_nombre_bienes4: bienes.liquidado_nombre_bienes4 || "",
        tipo_bienes5: bienes.tipo_bienes5 || "",
        ubicacion_bienes5: bienes.ubicacion_bienes5 || "",
        precio_bienes5: bienes.precio_bienes5 || "",
        liquidado_nombre_bienes5: bienes.liquidado_nombre_bienes5 || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    console.log("queryNotasBienes.data:", queryNotasBienes.data);
    if (queryNotasBienes.data && queryNotasBienes.data.length > 0) {
      const notas = queryNotasBienes.data[0];
      reset({
        nota_bienes1: notas.nota_bienes1 || "",
        nota_bienes2: notas.nota_bienes2 || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (querySituacionInmueble.data && querySituacionInmueble.data.length > 0) {
      const situacion = querySituacionInmueble.data[0];
      reset({
        situacion_del_inmueble: situacion.situacion_del_inmueble || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (queryZonaInmueble.data && queryZonaInmueble.data.length > 0) {
      const zona = queryZonaInmueble.data[0];
      reset({
        zona_del_inmueble: zona.zona_del_inmueble || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (queryTipoZona.data && queryTipoZona.data.length > 0) {
      const tipozona = queryTipoZona.data[0];
      reset({
        tipo_de_zona: tipozona.tipo_de_zona || "",
      });
    }
  }, [queryBienesRaices.data, reset]);

  useEffect(() => {
    if (
      querySituacionInmueble?.data &&
      querySituacionInmueble.data.length > 0
    ) {
      setSituacionSeleccionada(
        querySituacionInmueble.data[0]?.situacion_del_inmueble || null
      );
    }
  }, [querySituacionInmueble.data]);

  useEffect(() => {
    if (queryZonaInmueble?.data && queryZonaInmueble.data.length > 0) {
      setZonaSeleccionada(queryZonaInmueble.data[0]?.zona_del_inmueble || null);
    }
  }, [queryZonaInmueble.data]);

  useEffect(() => {
    if (queryTipoZona?.data && queryTipoZona.data.length > 0) {
      setTipoZonaSeleccionada(queryTipoZona.data[0]?.tipo_de_zona || null);
    }
  }, [queryTipoZona.data]);

  if (!situacionSeleccionada) {
    return <p>Cargando datos...</p>;
  }

  if (!zonaSeleccionada) {
    return <p>Cargando datos...</p>;
  }

  if (!tipoZonaSeleccionada) {
    return <p>Cargando datos...</p>;
  }

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA VISITA:
            </Label>
            <Controller
              name="fecha_bienesinmuebles"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_bienesinmuebles"
                  name="fecha_bienesinmuebles"
                  value={
                    queryFecha.data && queryFecha.data.length > 0
                      ? queryFecha.data[0].fecha_bienesinmuebles || ""
                      : ""
                  }
                  disabled={true}
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      {/* Seccion de Automovil */}
      <div className="mt-2">
        <div className="bg-slate-100 p-3 rounded-lg border border-gray-300">
          <img
            src={BarraBienesInmuebles}
            alt="HeaderDatosGenerales"
            className="rounded-lg"
          />
        </div>

        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300 mb-8">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            AUTOMÓVIL 1
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="marca"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MARCA:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="marca_autobienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="marca_autobienes1"
                        name="marca_autobienes1"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].marca_autobienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="modelo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MODELO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="modelo_autobienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="modelo_autobienes1"
                        name="modelo_autobienes1"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].modelo_autobienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precio"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_autobienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_autobienes1"
                        name="precio_autobienes1"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].precio_autobienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_autobienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_autobienes1"
                        name="liquidado_nombre_autobienes1"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].liquidado_nombre_autobienes1 ||
                              ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[75px]"></div>
        <div className="bg-slate-50 rounded-lg border border-gray-300 mt-8">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            AUTOMÓVIL 2
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="marca"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MARCA:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="marca_autobienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="marca_autobienes1"
                        name="marca_autobienes1"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].marca_autobienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="modelo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MODELO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="modelo_autobienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="modelo_autobienes2"
                        name="modelo_autobienes2"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].modelo_autobienes2 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precio"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_autobienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_autobienes2"
                        name="precio_autobienes2"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].precio_autobienes2 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_autobienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_autobienes2"
                        name="liquidado_nombre_autobienes2"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].liquidado_nombre_autobienes2 ||
                              ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            AUTOMÓVIL 3
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="marca"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MARCA:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="marca_autobienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="marca_autobienes3"
                        name="marca_autobienes3"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].marca_autobienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="modelo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MODELO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="modelo_autobienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="modelo_autobienes3"
                        name="modelo_autobienes3"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].modelo_autobienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precio"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_autobienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_autobienes3"
                        name="precio_autobienes3"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].precio_autobienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_autobienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_autobienes3"
                        name="liquidado_nombre_autobienes3"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].liquidado_nombre_autobienes3 ||
                              ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            AUTOMÓVIL 4
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="marca"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MARCA:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="marca_autobienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="marca_autobienes4"
                        name="marca_autobienes4"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].marca_autobienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="modelo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MODELO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="modelo_autobienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="modelo_autobienes4"
                        name="modelo_autobienes4"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].modelo_autobienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precio"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_autobienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_autobienes4"
                        name="precio_autobienes4"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].precio_autobienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_autobienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_autobienes4"
                        name="liquidado_nombre_autobienes4"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].liquidado_nombre_autobienes4 ||
                              ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[50px]"></div>
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            AUTOMÓVIL 5
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="marca"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MARCA:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="marca_autobienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="marca_autobienes5"
                        name="marca_autobienes5"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].marca_autobienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="modelo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    MODELO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="modelo_autobienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="modelo_autobienes5"
                        name="modelo_autobienes5"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].modelo_autobienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precio"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_autobienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_autobienes5"
                        name="precio_autobienes5"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].precio_autobienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_autobienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_autobienes5"
                        name="liquidado_nombre_autobienes5"
                        value={
                          queryAuto.data && queryAuto.data.length > 0
                            ? queryAuto.data[0].liquidado_nombre_autobienes5 ||
                              ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-[450px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
      <div className="mt-[450px]"></div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[150%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Seccion Bienes Raices */}
      <div className="mt-2">
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            BIENES RAÍCES 1
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="tipo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    TIPO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="tipo_bienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="tipo_bienes1"
                        name="tipo_bienes1"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].tipo_bienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="ubicacion"
                    className="block text-sm font-medium text-gray-700"
                  >
                    UBICACIÓN:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="ubicacion_bienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="ubicacion_bienes1"
                        name="ubicacion_bienes1"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].ubicacion_bienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precioEstimado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_bienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_bienes1"
                        name="precio_bienes1"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].precio_bienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidadoNombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_bienes1"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_bienes1"
                        name="liquidado_nombre_bienes1"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0]
                                .liquidado_nombre_bienes1 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-2">
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            BIENES RAÍCES 2
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="tipo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    TIPO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="tipo_bienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="tipo_bienes2"
                        name="tipo_bienes2"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].tipo_bienes2 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="ubicacion"
                    className="block text-sm font-medium text-gray-700"
                  >
                    UBICACIÓN:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="ubicacion_bienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="ubicacion_bienes2"
                        name="ubicacion_bienes2"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].ubicacion_bienes2 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precioEstimado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_bienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_bienes2"
                        name="precio_bienes2"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].precio_bienes2 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidadoNombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_bienes2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_bienes2"
                        name="liquidado_nombre_bienes2"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0]
                                .liquidado_nombre_bienes2 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-[100px]"></div>
      <div className="mt-2">
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            BIENES RAÍCES 3
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="tipo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    TIPO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="tipo_bienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="tipo_bienes3"
                        name="tipo_bienes3"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].tipo_bienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="ubicacion"
                    className="block text-sm font-medium text-gray-700"
                  >
                    UBICACIÓN:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="ubicacion_bienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="ubicacion_bienes3"
                        name="ubicacion_bienes3"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].ubicacion_bienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precioEstimado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_bienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_bienes3"
                        name="precio_bienes3"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].precio_bienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidadoNombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_bienes3"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_bienes3"
                        name="liquidado_nombre_bienes3"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0]
                                .liquidado_nombre_bienes3 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-2">
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            BIENES RAÍCES 4
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="tipo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    TIPO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="tipo_bienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="tipo_bienes4"
                        name="tipo_bienes4"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].tipo_bienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="ubicacion"
                    className="block text-sm font-medium text-gray-700"
                  >
                    UBICACIÓN:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="ubicacion_bienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="ubicacion_bienes4"
                        name="ubicacion_bienes4"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].ubicacion_bienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precioEstimado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_bienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_bienes4"
                        name="precio_bienes4"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].precio_bienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidadoNombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_bienes4"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_bienes4"
                        name="liquidado_nombre_bienes4"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0]
                                .liquidado_nombre_bienes4 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-[250px]"></div>
      <div className="mt-2">
        <div className="bg-slate-50 p-4 rounded-lg border border-gray-300">
          <h3 className="text-center text-sm font-semibold text-gray-700 mb-4 border-b border-gray-300 pb-2">
            BIENES RAÍCES 5
          </h3>
          <table className="w-full border-collapse">
            <tbody>
              <tr>
                <td className="border border-gray-300 p-2 w-1/3">
                  <label
                    htmlFor="tipo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    TIPO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2 w-2/3">
                  <Controller
                    name="tipo_bienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="tipo_bienes5"
                        name="tipo_bienes5"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].tipo_bienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="ubicacion"
                    className="block text-sm font-medium text-gray-700"
                  >
                    UBICACIÓN:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="ubicacion_bienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="ubicacion_bienes5"
                        name="ubicacion_bienes5"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].ubicacion_bienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="precioEstimado"
                    className="block text-sm font-medium text-gray-700"
                  >
                    PRECIO ESTIMADO:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="precio_bienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="precio_bienes5"
                        name="precio_bienes5"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0].precio_bienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-2">
                  <label
                    htmlFor="liquidadoNombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    LIQUIDADO A NOMBRE DE:
                  </label>
                </td>
                <td className="border border-gray-300 p-2">
                  <Controller
                    name="liquidado_nombre_bienes5"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="liquidado_nombre_bienes5"
                        name="liquidado_nombre_bienes5"
                        value={
                          queryBienesRaices.data &&
                          queryBienesRaices.data.length > 0
                            ? queryBienesRaices.data[0]
                                .liquidado_nombre_bienes5 || ""
                            : ""
                        }
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-[50px]"></div>
      {/* Sección de Notas */}
      <div className="border border-gray-300 mt-1">
        <div className="bg-blue-100 p-1 text-center font-semibold text-gray-700 border-b border-gray-300">
          NOTAS
        </div>
        <Controller
          name="nota_bienes1"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              id="nota_bienes1"
              name="nota_bienes1"
              value={
                queryNotasBienes.data && queryNotasBienes.data.length > 0
                  ? queryNotasBienes.data[0].nota_bienes1 || ""
                  : ""
              }
              disabled={true}
              className="bg-blue-100 p-1 text-gray-700 border border-gray-300 w-full h-12"
            />
          )}
        />
      </div>

      {/* Tabla de Situación del inmueble */}
      <div className="border border-gray-300 mt-2">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          SITUACIÓN DEL INMUEBLE
        </div>
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              {[
                "PROPIO",
                "RENTADO",
                "HIPOTECADO",
                "PRESTADO",
                "COMPARTIDO",
              ].map((item) => (
                <td
                  key={item}
                  className="border border-gray-300 p-2 text-center"
                >
                  <label className="flex items-center justify-center space-x-2">
                    <span className="text-sm">{item}</span>
                    <Checkbox
                      checked={situacionSeleccionada === item}
                      className="form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                      aria-label={item}
                    />
                  </label>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      {/* Tabla de Tipo de Zona */}
      <div className="border border-gray-300">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          TIPO DE ZONA
        </div>
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              {["ALTA", "MEDIA ALTA", "MEDIA", "MEDIA BAJA", "BAJA"].map(
                (item2) => (
                  <td
                    key={item2}
                    className="border border-gray-300 p-2 text-center"
                  >
                    <label className="flex items-center justify-center space-x-2">
                      <span className="text-sm">{item2}</span>
                      <Checkbox
                        checked={zonaSeleccionada === item2}
                        className="form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                        aria-label={item2}
                      />
                    </label>
                  </td>
                )
              )}
            </tr>
          </tbody>
        </table>
      </div>
      {/* Tabla de Zona */}
      <div className="border border-gray-300">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          ZONA
        </div>
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              {["URBANA", "RURAL", "SUBURBANA"].map((item3) => (
                <td
                  key={item3}
                  className="border border-gray-300 p-2 text-center"
                >
                  <label className="flex items-center justify-center space-x-2">
                    <span className="text-sm">{item3}</span>
                    <Checkbox
                      checked={tipoZonaSeleccionada === item3}
                      className="form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                      aria-label={item3}
                    />
                  </label>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
      <div className="mt-[300px]"></div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Marca de agua 3 */}
      <div className="absolute inset-0 top-[250%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Sección de Notas */}
      <div className="border border-gray-300 rounded-lg shadow-md mt-4 overflow-hidden">
        <div className="bg-blue-500 p-3 text-center font-semibold text-white">
          NOTAS
        </div>
        <Controller
          name="nota_bienes2"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              id="nota_bienes2"
              name="nota_bienes2"
              value={
                queryNotasBienes.data && queryNotasBienes.data.length > 0
                  ? queryNotasBienes.data[0].nota_bienes2 || ""
                  : ""
              }
              disabled={true}
              className="bg-gray-50 p-3 text-gray-700 border-t border-gray-300 w-full resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Escribe aquí tus notas..."
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement;
                target.style.height = "auto";
                target.style.height = `${target.scrollHeight}px`;
              }}
              style={{ height: "auto", overflow: "hidden" }}
            />
          )}
        />
      </div>
      <div className="mt-[450px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
    </div>
  );
};
